module.exports = __webpack_public_path__ + "img/lead-101e.a62291a7.png";